import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 py-12 mt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <img 
            src="https://www.cefatransportes.com/img/logo2.png" 
            alt="CEFA Transportes Logo" 
            className="h-16 mx-auto mb-6"
          />
        </div>

        <nav className="flex flex-wrap justify-center gap-6 mb-8">
          <Link to="/aviso-legal" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Aviso Legal
          </Link>
          <Link to="/politicas-privacidad" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Políticas de Privacidad
          </Link>
          <Link to="/politica-calidad" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Política de Calidad
          </Link>
          <Link to="/politica-cookies" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Política de Cookies
          </Link>
          <Link to="/politica-ventas" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Política de Ventas
          </Link>
          <Link to="/codigo-conducta" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Código de Conducta
          </Link>
          <Link to="/contacto" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Contacto
          </Link>
          <Link to="/conocenos" className="text-gray-600 hover:text-orange-500 text-sm uppercase font-medium transition-colors">
            Conócenos
          </Link>
        </nav>

        <div className="flex justify-center gap-6 mb-8">
          <a 
            href="https://es-es.facebook.com/cefa.formacion" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white rounded-full transition-colors cursor-pointer"
          >
            <i className="fab fa-facebook text-xl"></i>
          </a>
          <a 
            href="https://www.instagram.com/instituto_cefa/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white rounded-full transition-colors cursor-pointer"
          >
            <i className="fab fa-instagram text-xl"></i>
          </a>
        </div>

        <div className="text-center">
          <p className="text-gray-600 text-sm mb-2">
            Todos los derechos reservados. Copyright © Cefa Transportes S.L. 2025.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-orange-500 text-xs transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
